import {
  FontWeight,
  LiliButton,
  LiliTextInput,
  LiliButtonType,
  HeadingVariant,
  Heading,
} from '@lili/lili-frontend-common';
import { FormProvider } from 'react-hook-form';
import { useTranslation, Trans } from 'react-i18next';
import { OnboardingFormFields, SUBMIT_BUTTON_ID } from '@Types/index';
import { ControllerWrapper } from '@Hooks/index';
import logoUrl from '@Assets/logos/lili-logo-blue.svg';
import { PasswordInputWithoutHints } from '@Components/inputs/PasswordInput';
import { useResizeListener } from '@Hooks/custom/useResizeListener';
import { ForgotPasswordModal } from '@Components/modal/ForgotPasswordModal';
import { useLoginLogic } from './useLoginLogic';

export const LoginPage = () => {
  const {
    formMethods,
    handleLogin,
    isPending,
    initRecoveryFlow,
    isForgotPasswordModalOpen,
    closeForgotPasswordModal,
  } = useLoginLogic();
  const { t } = useTranslation();

  const { isMobile } = useResizeListener();

  return (
    <div className='flex flex-col items-center justify-center w-full h-full bg-surface-primary-bw-02'>
      <div className='w-full h-full md:w-[500px] md:h-[502px] flex flex-col animate-fadeIn shadow-lg bg-text-main-primary-inverse py-[40px] px-[16px] md:rounded-md md:pt-[40px] md:pb-[28px] md:px-[40px]'>
        <img src={logoUrl} alt='Lili Logo' className='w-[98px] md:w-[58px] mx-auto mb-[12px]' />
        <Heading
          variant={isMobile ? HeadingVariant.H7 : HeadingVariant.H5}
          fontWeight={FontWeight.SEMIBOLD}
          className='text-center mb-[24px]'>
          <Trans i18nKey='pages.login.title' />
        </Heading>
        <FormProvider {...formMethods}>
          <ControllerWrapper name={OnboardingFormFields.EMAIL} control={formMethods.control}>
            {({ value, onChange, onBlur, error }) => (
              <LiliTextInput
                id={OnboardingFormFields.EMAIL}
                title={t('pages.home.email')}
                value={value}
                onChange={onChange}
                onBlur={onBlur}
                errorMessage={error?.message}
                isPublic={false}
              />
            )}
          </ControllerWrapper>
          <PasswordInputWithoutHints />
          <LiliButton
            isLoading={isPending}
            onClick={handleLogin}
            disabled={!formMethods.formState.isValid}
            title={t('pages.login.cta')}
            id={SUBMIT_BUTTON_ID}
            className='mt-auto md:mt-[32px]'
          />
          <LiliButton
            id='forgot-password'
            title={t('pages.login.forgotPassword')}
            onClick={initRecoveryFlow}
            className='mt-[24px] py-[0px] mx-auto text-text-brand-primary font-metric text-[14px] w-fit'
            type={LiliButtonType.SKIP}
          />
        </FormProvider>
        <ForgotPasswordModal
          isOpen={isForgotPasswordModalOpen}
          onPrimaryAction={initRecoveryFlow}
          onClose={closeForgotPasswordModal}
          isLoading={isPending}
        />
      </div>
    </div>
  );
};
